"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeCosmosFlag = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

/**
 * Initializes the cosmos flag by fetching from the LaunchDarkly API
 * If the API returns 404 or fails, defaults to false (normal client-side routing)
 * @returns {Promise<boolean>} The value of the quixel-cosmos flag
 */
var initializeCosmosFlag = exports.initializeCosmosFlag = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var response, flags;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!flagInitialized) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", isCosmosEnabled);

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return fetch("/api/cosmos/launch-darkly-flags");

          case 5:
            response = _context.sent;

            if (response.ok) {
              _context.next = 11;
              break;
            }

            console.log("LaunchDarkly flags API returned non-OK status, defaulting to client-side routing");
            isCosmosEnabled = false;
            flagInitialized = true;
            return _context.abrupt("return", false);

          case 11:
            _context.next = 13;
            return response.json();

          case 13:
            flags = _context.sent;

            isCosmosEnabled = flags["quixel-cosmos"] === true;
            flagInitialized = true;

            if (isCosmosEnabled) {
              console.log("Cosmos mode enabled: Using full page refreshes for navigation");
            }

            return _context.abrupt("return", isCosmosEnabled);

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](2);

            // On any error (network, parse, etc.), default to false
            console.log("Error fetching LaunchDarkly flags, defaulting to client-side routing:", _context.t0);
            isCosmosEnabled = false;
            flagInitialized = true;
            return _context.abrupt("return", false);

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[2, 20]]);
  }));

  return function initializeCosmosFlag() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Gets the current state of the cosmos flag
 * @returns {boolean}
 */


exports.getIsCosmosEnabled = getIsCosmosEnabled;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Module-level variable to store the cosmos flag state
var isCosmosEnabled = false;
var flagInitialized = false;function getIsCosmosEnabled() {
  return isCosmosEnabled;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/cosmosNavigation.js
// module id = 1163
// module chunks = 0